import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageTitle } from '../../../_metronic/layout/core';
import { SubscriptionsTab } from './components/SubscriptionsTab';

import { LinkGenerator } from './components/LinkGenerator';
import { ChargesTab } from './components/ChargesTab';
import { SubscriptionStatsTab } from './components/SubscriptionStatsTab';
import { useAuth } from '../../modules/auth';
import { WhiteLabelProvider } from './components/WhiteLabelProvider';

type SubscriptionTab = 'estatisticas' | 'assinaturas' | 'links' | 'cobrancas';

const SUBSCRIPTION_TABS: SubscriptionTab[] = ['estatisticas', 'assinaturas', 'links', 'cobrancas'];

const isSubscriptionTab = (value: string | null): value is SubscriptionTab =>
  SUBSCRIPTION_TABS.includes(value as SubscriptionTab);

const SubscriptionsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab: SubscriptionTab = isSubscriptionTab(tabParam) ? tabParam : 'estatisticas';

  const setActiveTab = (tab: SubscriptionTab) => {
    setSearchParams(tab === 'estatisticas' ? {} : { tab }, { replace: true });
  };

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <h3 className='card-title align-items-start flex-column mb-7'>
            <span className='card-label fw-bolder fs-3 mb-1'>Gestão de Assinaturas</span>
          </h3>
          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'estatisticas' && 'active'}`}
                  onClick={() => setActiveTab('estatisticas')}
                  style={{ cursor: 'pointer' }}
                >
                  Estatísticas
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'assinaturas' && 'active'}`}
                  onClick={() => setActiveTab('assinaturas')}
                  style={{ cursor: 'pointer' }}
                >
                  Assinaturas
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'cobrancas' && 'active'}`}
                  onClick={() => setActiveTab('cobrancas')}
                  style={{ cursor: 'pointer' }}
                >
                  Cobranças
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link text-active-primary me-6 ${activeTab === 'links' && 'active'}`}
                  onClick={() => setActiveTab('links')}
                  style={{ cursor: 'pointer' }}
                >
                  Gerador de Link
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className='tab-content'>
        {activeTab === 'estatisticas' && <SubscriptionStatsTab />}
        {activeTab === 'assinaturas' && <SubscriptionsTab />}
        {activeTab === 'cobrancas' && <ChargesTab />}
        {activeTab === 'links' && <LinkGenerator />}
      </div>
    </>
  );
};

export const SubscriptionsWrapper: React.FC = () => {
  const { currentUser } = useAuth();
  const company = currentUser?.companies && currentUser.companies.length > 0 ? currentUser.companies[0] : null;

  return (
    <WhiteLabelProvider company={company}>
      <PageTitle breadcrumbs={[]}>Gestão de Assinaturas</PageTitle>
      <SubscriptionsPage />
    </WhiteLabelProvider>
  );
};
